import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Card, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { api } from '../../utils/api'
import { getFromStorage } from '../../utils/storage'
import axios from 'axios'
import { handleError } from '../../utils/error'
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, loadingActions } from '../../redux/store'
import Loading from '../../components/Loading'
import { mainGreen, mainRed } from '../../utils/color'

export default function StoreManagement() {
	const { isLoading } = useSelector((state) => state.isLoading)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [stores, setStores] = useState([])
	const getStores = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: api.GET_STORES_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStores(response.data)
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, dispatch, navigate],
	)

	useEffect(() => {
		getStores()
	}, [getStores])

	const deleteStore = async function (storeId) {
		try {
			const response = await axios({
				url: api.DELETE_STORE_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { storeId },
				method: 'DELETE',
				withCredentials: true,
			})
			await getStores()
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			{isLoading ? (
				<Loading />
			) : (
				<Box sx={{ maxWidth: 992, marginLeft: 'auto', marginRight: 'auto' }}>
					<Box sx={{ marginTop: '10px', padding: '20px' }}>
						<Button
							size='medium'
							variant='contained'
							sx={{
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							onClick={() => {
								navigate('/admin/signup-store')
							}}>
							<AddBusinessOutlinedIcon sx={{ mr: 1 }} /> Đăng ký cửa hàng
						</Button>
					</Box>
					{stores?.map((store, index) => {
						return (
							<Card sx={{ margin: '10px 0', padding: '10px' }} key={index}>
								<Typography sx={{ mb: 1 }}>Tên: {store.name}</Typography>
								<Box display='flex' justifyContent='space-between' alignItems='flex-end'>
									<Button
										size='small'
										variant='contained'
										sx={{
											background: mainGreen,
											'&:hover': { background: mainGreen },
										}}
										onClick={() => {
											navigate(`/admin/edit-store/${store._id}`)
										}}>
										Thay đổi thông tin
									</Button>
									<Button
										sx={{
											marginLeft: 'auto',
											p: 0,
											background: mainRed,
											'&:hover': { background: mainRed },
										}}
										size='small'
										variant='contained'
										onClick={() => {
											const confirmDelete = window.confirm('Bạn có chắc muốn xóa cửa hàng này?')
											if (confirmDelete) {
												deleteStore(store._id)
											}
										}}>
										Xóa
									</Button>
								</Box>
							</Card>
						)
					})}
				</Box>
			)}
		</UserLayout>
	)
}
